import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';

export default function SustainabilityCTA() {
  const { t } = useLanguage();

  const pillars = [
    { icon: 'ri-flask-line', text: t('原料評估', 'Material Assessment', '材料評価') },
    { icon: 'ri-box-3-line', text: t('產品開發', 'Product Development', '製品開発') },
    { icon: 'ri-settings-3-line', text: t('製程導入', 'Process Implementation', '製造工程導入') },
    { icon: 'ri-bar-chart-line', text: t('ESG 數據整理', 'ESG Data Compilation', 'ESGデータ整理') },
  ];

  return (
    <section className="relative section-padding overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-top"
        style={{
          backgroundImage:
            'url(https://readdy.ai/api/search-image?query=green%20sustainable%20future%20circular%20economy%20recycled%20plastic%20ESG%20carbon%20neutral%20nature%20and%20technology%20balance%20inspiring%20wide%20angle%20photography%20green%20and%20blue%20accent%20lighting%20clean%20environment%20high%20resolution%20professional&width=1440&height=560&seq=sustain-cta-v1&orientation=landscape)',
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-br from-black/75 via-black/62 to-black/50" />
      <div className="absolute top-0 right-0 w-[500px] h-[500px] opacity-20 pointer-events-none" style={{ background: 'radial-gradient(circle, rgba(0,184,148,0.30) 0%, transparent 65%)', zIndex: 1 }} aria-hidden="true" />

      <div className="relative z-10 max-w-screen-xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-gradient-to-br from-brand-green to-brand-blue mx-auto mb-6">
            <i className="ri-earth-line text-white text-3xl"></i>
          </div>
          <h2
            className="font-bold text-white mb-5"
            style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)', lineHeight: '1.4' }}
          >
            {t(
              '想把再生塑膠導入 ESG 與低碳產品策略？',
              'Want to Integrate Recycled Plastics into Your ESG & Low-Carbon Product Strategy?',
              '再生プラスチックをESG・低炭素製品戦略に組み込みたいですか？'
            )}
          </h2>
          <p className="text-white/82 mb-8 max-w-xl mx-auto" style={{ fontSize: '1.1875rem', lineHeight: '1.75' }}>
            {t(
              '聚量可協助評估原料、產品、製程與應用場景，讓永續從理念走向材料、產品與市場。',
              'PolyQ can assist in evaluating raw materials, products, processes, and application scenarios, moving sustainability from concept to materials, products, and markets.',
              '聚量は原料・製品・製造工程・応用シーンの評価を支援し、サステナビリティを理念から材料・製品・市場へと転換します。'
            )}
          </p>
          <div className="flex flex-wrap justify-center gap-3 mb-9">
            {pillars.map((p) => (
              <div key={p.text} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/12 border border-white/25 backdrop-blur-sm">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className={`${p.icon} text-brand-green text-base`}></i>
                </div>
                <span className="text-white text-[1rem] font-medium whitespace-nowrap">{p.text}</span>
              </div>
            ))}
          </div>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-brand-green text-white text-[1.0625rem] font-semibold hover:bg-brand-green-dark transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-mail-send-line"></i>
            {t('聯絡我們', 'Contact Us', 'お問い合わせ')}
          </Link>
          <div className="mt-10 flex flex-wrap justify-center gap-6">
            {[
              { icon: 'ri-government-line', text: t('台中市政府 SBIR 計畫', 'Taichung City Government SBIR Program', '台中市政府SBIRプログラム') },
              { icon: 'ri-award-line', text: t('台灣 · 日本 · 歐盟 · 美國專利', 'TW · JP · EU · US Patents', '台湾・日本・EU・米国特許') },
              { icon: 'ri-recycle-line', text: t('環保局再利用許可', 'EPA Recycling Permit', '環境保護局再利用許可') },
            ].map((item) => (
              <div key={item.text} className="flex items-center gap-2 text-white/75 text-[1rem]">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className={`${item.icon} text-brand-green`}></i>
                </div>
                <span>{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
